// client/src/components/Auth/OAuthSuccess.js
import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';
import SEOHead from '../SEO/SEOHead';

const OAuthSuccess = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { setUser, setToken } = useAuth();
    const hasProcessed = useRef(false); // Prevent double processing

    useEffect(() => {
        // Only process once to prevent infinite loops
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const token = searchParams.get('token');
        const userParam = searchParams.get('user');

        if (token && userParam) {
            try {
                const user = JSON.parse(decodeURIComponent(userParam));
                
                // Store token and user data
                localStorage.setItem('token', token);
                localStorage.setItem('user', JSON.stringify(user));
                
                setToken(token);
                setUser(user);

                // Redirect to dashboard
                navigate('/dashboard', { replace: true });
            } catch (error) {
                console.error('Error parsing OAuth response:', error);
                navigate('/login?error=oauth_parse_error', { replace: true });
            }
        } else {
            // No token or user data, redirect to login with error
            navigate('/login?error=oauth_missing_data', { replace: true });
        }
    }, [searchParams, navigate, setUser, setToken]);

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="100vh"
            gap={2}
        >
            <SEOHead title="Signing In" noIndex={true} canonical="/oauth/success" description="Completing sign in to SoldiKeeper." />
            <CircularProgress size={60} />
            <Typography variant="h6" color="textSecondary">
                Completing sign in...
            </Typography>
        </Box>
    );
};

export default OAuthSuccess;
